import { MenuItem } from "react-pro-sidebar";
import { styled } from "styled-components";

export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.subtle};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 400;
  text-decoration: none;

  a {
    color: inherit;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: 400;

    &:hover {
      color: ${({ theme }) => theme.colors.text} !important;
      background-color: transparent !important;
    }

    &.ps-active {
      color: ${({ theme }) => theme.colors.text} !important;
      background-color: transparent !important;
    }

    .ps-menu-icon {
      &.ps-active {
        color: ${({ theme }) => theme.colors.primary} !important;
        background-color: transparent !important;
      }
    }
  }
`;
